export default __webpack_public_path__ + "static/media/bd_logo_circle.25f44d39.png";